import { atom } from 'recoil';

type StatusType = 'idle';

export type OrderChatAtomType = {
    status: { active: StatusType }
}

export const orderChatAtom = atom<OrderChatAtomType>({
    key: 'orderChatAtom',
    default: {
        status: {
            active: 'idle'
        }
    },
});

export type ProductChatAtomType = {
    status: { active: StatusType }
}

export const productChatAtom = atom<ProductChatAtomType>({
    key: 'productChatAtom',
    default: {
        status: {
            active: 'idle'
        }
    },
});


export type suppliperChatAtomType = {
    status: { active: StatusType }
}

export const supplierChatAtom = atom<suppliperChatAtomType>({
    key: 'supplierChatAtom',
    default: {
        status: {
            active: 'idle'
        }
    },
});


export type statusChatAtomType = {
    status: { order: boolean, product: boolean, supplier: boolean },
    info: {}
}

export const statusChatAtom = atom<statusChatAtomType>({
    key: 'statusChatAtom',
    default: {
        status: {
            order: false,
            product: false,
            supplier: false
        },
        info: {}
    },
});

